module.exports = __webpack_public_path__ + "static/media/state_pmg_icon.2bd3a7af.svg";